import { useCallback } from "react";
import useBookInfo from "../bookinfo/useBookInfo";
import { useBrand } from "../../../../../common/providers/brand/brand-context";

const useFeatureFlag = () => {
  const brand = useBrand();
  const { bookInfo } = useBookInfo();

  const isRequired = (key) => !!key;

  const enabledFromBrand = useCallback(
    (key) => {
      if (!isRequired(key)) {
        return true;
      }

      return brand.getProp(key);
    },
    [brand]
  );
  const enabledFromAsset = useCallback(
    (key) => {
      if (!isRequired(key)) {
        return true;
      }
      return bookInfo.features.find(
        (feature) => feature.name.toLowerCase() === key
      );
    },
    [bookInfo]
  );

  const isFeatureEnabled = useCallback(
    ({ brandKey, assetKey }) =>
      enabledFromAsset(assetKey) && enabledFromBrand(brandKey),
    [enabledFromAsset, enabledFromBrand]
  );

  return isFeatureEnabled;
};
export default useFeatureFlag;
